/**
 * Product Waitlist / Back-In-Stock popup trigger handler
 */
(function () {
  'use strict';

  if (window.__arzopaWaitlistHandlerInitialized) return;
  window.__arzopaWaitlistHandlerInitialized = true;

  /**
   * Triggers the configured or auto-detected app subscription popup.
   * @param {HTMLElement} btn The button element that was clicked.
   */
  window.triggerWaitlistPopup = function (btn) {
    if (!btn) return;

    const customJs = btn.getAttribute('data-custom-js');
    const popupLink =
      btn.getAttribute('data-waitlist-popup-link') ||
      btn.getAttribute('href') ||
      btn.getAttribute('data-trigger-selector') ||
      '';
    const modalId = btn.getAttribute('data-modal-id');
    const productInfo = btn.closest('product-info') || document.querySelector('product-info');
    const productId = btn.getAttribute('data-product-id') || productInfo?.dataset?.productId || '';
    const variantId =
      btn.getAttribute('data-variant-id') ||
      productInfo?.querySelector('[name="id"]')?.value ||
      '';
    const productTitle =
      btn.getAttribute('data-product-title') ||
      document.querySelector('.product__title')?.textContent?.trim() ||
      '';
    const variantTitle = btn.getAttribute('data-variant-title') || '';

    const detail = {
      productId,
      variantId,
      productTitle,
      variantTitle,
      popupLink,
      button: btn,
    };

    // 1. Custom JavaScript trigger execution (if configured)
    if (customJs && customJs.trim() !== '') {
      try {
        const fn = new Function('product', 'variant', 'btn', 'detail', customJs);
        const res = fn(
          { id: productId, title: productTitle },
          { id: variantId, title: variantTitle },
          btn,
          detail
        );
        if (res !== false) {
          dispatchWaitlistEvents(detail);
          return;
        }
      } catch (err) {
        console.warn('[Waitlist] Custom JS execution failed:', err);
      }
    }

    // 2. Popup trigger link / Hash trigger (e.g. #Ecomsend_popups_open_359290 or #sendwill-popup)
    if (popupLink && popupLink.trim() !== '') {
      const trimmedLink = popupLink.trim();

      if (trimmedLink.startsWith('#')) {
        // 2a. Check if an element matching this ID exists and can be opened
        const targetEl = document.querySelector(trimmedLink);
        if (targetEl && targetEl !== btn) {
          if (typeof targetEl.showModal === 'function') {
            targetEl.showModal();
            dispatchWaitlistEvents(detail);
            return;
          }
          if (typeof targetEl.open === 'function') {
            targetEl.open();
            dispatchWaitlistEvents(detail);
            return;
          }
          if (typeof targetEl.show === 'function') {
            targetEl.show();
            dispatchWaitlistEvents(detail);
            return;
          }
        }

        // 2b. Create and click a virtual anchor tag (standard for Ecomsend / CwillSendwill)
        const virtualLink = document.createElement('a');
        virtualLink.href = trimmedLink;
        virtualLink.style.display = 'none';
        document.body.appendChild(virtualLink);
        virtualLink.click();
        virtualLink.remove();

        // 2c. Dispatch hashchange / location update
        try {
          if (window.location.hash !== trimmedLink) {
            window.location.hash = trimmedLink;
          }
          window.dispatchEvent(new HashChangeEvent('hashchange'));
        } catch (e) {}

        // 2d. Trigger any existing link matching the hash
        const existingLink = document.querySelector(`a[href="${trimmedLink}"]`);
        if (existingLink && existingLink !== btn) {
          existingLink.click();
        }

        dispatchWaitlistEvents(detail);
        return;
      } else {
        // Selector trigger (e.g. .globo-form-open or [data-popup])
        try {
          const target = document.querySelector(trimmedLink);
          if (target && target !== btn) {
            if (typeof target.showModal === 'function') {
              target.showModal();
            } else if (typeof target.open === 'function') {
              target.open();
            } else if (typeof target.show === 'function') {
              target.show();
            } else {
              target.click();
            }
            dispatchWaitlistEvents(detail);
            return;
          }
        } catch (err) {
          console.warn('[Waitlist] Selector trigger failed:', trimmedLink, err);
        }
      }
    }

    // 3. Theme/App Modal ID trigger (if configured)
    if (modalId && modalId.trim() !== '') {
      const modal = document.getElementById(modalId);
      if (modal) {
        if (typeof modal.show === 'function') {
          modal.show();
          dispatchWaitlistEvents(detail);
          return;
        }
        if (typeof modal.open === 'function') {
          modal.open();
          dispatchWaitlistEvents(detail);
          return;
        }
        if (typeof modal.showModal === 'function') {
          modal.showModal();
          dispatchWaitlistEvents(detail);
          return;
        }
        const opener = document.querySelector(`[aria-controls="${modalId}"]`);
        if (opener && opener !== btn) {
          opener.click();
          dispatchWaitlistEvents(detail);
          return;
        }
        modal.removeAttribute('hidden');
        modal.classList.add('is-open', 'active');
        dispatchWaitlistEvents(detail);
        return;
      }
    }

    // 4. Auto-detect installed Back-in-Stock / Subscription plugins:
    // 4a. EcomSend / CwillSendwill / Sendwill Popup Email app
    const sendwillTrigger = document.querySelector(
      '.cw-popup-trigger, [data-sendwill-trigger], .cwill-popup, .sendwill-popup-btn, [data-cw-popup], a[href*="Ecomsend_popups_open"]'
    );
    if (sendwillTrigger && sendwillTrigger !== btn) {
      sendwillTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }
    if (window.CwillSendwill?.openPopup || window.Sendwill?.open || window.EcomSend?.open) {
      (window.CwillSendwill?.openPopup || window.Sendwill?.open || window.EcomSend?.open)();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4b. Powerful Form Builder / Globo Form Builder
    const globoTrigger = document.querySelector(
      '.globo-form-open, .gfb-open-modal, [data-globo-form-id], .globo-form-app [data-id]'
    );
    if (globoTrigger && globoTrigger !== btn) {
      globoTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }
    if (window.GloboFormBuilder?.openModal) {
      window.GloboFormBuilder.openModal();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4c. Shopify Forms app
    const formsTrigger = document.querySelector(
      '[data-forms-open], .shopify-forms-button, [aria-controls^="shopify-forms"]'
    );
    if (formsTrigger && formsTrigger !== btn) {
      formsTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }
    if (window.Shopify?.forms?.open) {
      window.Shopify.forms.open();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4d. Brevo / PushOwl BIS
    if (window.pushowl?.triggerBackInStock) {
      window.pushowl.triggerBackInStock({ variantId: variantId ? Number(variantId) : undefined });
      dispatchWaitlistEvents(detail);
      return;
    }
    const pushowlTrigger = document.querySelector('.pushowl-widget, .pushowl-bis-btn, .pushowl-trigger');
    if (pushowlTrigger && pushowlTrigger !== btn) {
      pushowlTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4e. Klaviyo Back in Stock / Form
    if (window._klOnsite) {
      try {
        window._klOnsite.push(['openForm']);
      } catch (e) {}
    }
    const klaviyoTrigger = document.querySelector('.klaviyo-bis-trigger, .klaviyo-custom-trigger');
    if (klaviyoTrigger && klaviyoTrigger !== btn) {
      klaviyoTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4f. Swym / Restock Rocket / Vitals / Other BIS plugins
    const otherBisTrigger = document.querySelector(
      '.swym-button, .swym-add-to-watchlist, .vitals-restock-btn, [data-vitals-app="restock"], .bis-trigger, .restock-rocket-btn, .notify-me-btn, [data-bis-trigger], .back-in-stock-btn, [data-restock-trigger]'
    );
    if (otherBisTrigger && otherBisTrigger !== btn) {
      otherBisTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4g. Theme subscription popup fallback
    const themePopup = document.querySelector('subscription-popup, [id^="SubscriptionModal-"]');
    if (themePopup) {
      if (typeof themePopup.show === 'function') {
        themePopup.show();
        dispatchWaitlistEvents(detail);
        return;
      }
      if (typeof themePopup.open === 'function') {
        themePopup.open();
        dispatchWaitlistEvents(detail);
        return;
      }
      const themePopupOpener = document.querySelector(`[aria-controls="${themePopup.id}"]`);
      if (themePopupOpener && themePopupOpener !== btn) {
        themePopupOpener.click();
        dispatchWaitlistEvents(detail);
        return;
      }
      themePopup.removeAttribute('hidden');
      themePopup.classList.add('is-open');
      dispatchWaitlistEvents(detail);
      return;
    }

    // 5. Final fallback: dispatch CustomEvents so any registered script catches it
    dispatchWaitlistEvents(detail);
  };

  function dispatchWaitlistEvents(detail) {
    document.dispatchEvent(new CustomEvent('waitlist:open', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('open:waitlist-popup', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('shopify:forms:open', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('bis:open', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('theme:waitlist:clicked', { bubbles: true, detail }));
  }

  // Delegated click listener for all waitlist buttons
  document.addEventListener(
    'click',
    function (event) {
      const waitlistBtn = event.target.closest(
        '[data-waitlist-trigger="true"], .btn--waitlist, [data-waitlist-trigger]'
      );
      if (!waitlistBtn) return;

      event.preventDefault();
      event.stopPropagation();
      window.triggerWaitlistPopup(waitlistBtn);
    },
    true
  );
})();
